/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesLocationZipCodes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Location Zip Code Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Tuesday, May 14, 2019 - 04:49:33 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      05/14/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const LocationZipCodeList = Loadable({
    loader: () => import('../containers/LocationZipCodes/LocationZipCodeListContainer'),
    loading: Loading,
});

export const LocationZipCodeForm = Loadable({
    loader: () => import('../containers/LocationZipCodes/LocationZipCodeEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesLocationZipCodes.js